/**
 * @description Searches a string and replaces matching strings with another value
 *
 * @see Inspiration Taken from here https://stackoverflow.com/questions/5069464/replace-multiple-strings-at-once/34560648#34560648 and modified
 *
 * @param {string} str String with keys that match the props in replacements
 * @param {Record<string, string>} replacements Data to replace matching keys in str
 * @returns {string} str with replacements
 */
export var replaceAllInString = function (str, replacements) {
    var regexArray = [];
    var map = {};
    var findArray = Object.keys(replacements);
    var replaceArray = Object.values(replacements);
    for (var i = 0; i < findArray.length; i += 1) {
        regexArray.push(findArray[i].replace(/([#$()*+,.?[\\\]^{|}-])/g, '\\$1'));
        map[findArray[i]] = replaceArray[i];
    }
    var regex = regexArray.join('|');
    str = str.replace(new RegExp(regex, 'g'), function (matched) { return map[matched]; });
    return str;
};
//# sourceMappingURL=replaceAllInString.js.map